export const USER = 'User';
export const DATE = 'Date';
export const AMOUNT = 'Amount';
export const DESCRIPTION = 'Description';
export const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
	'July', 'August', 'September', 'October', 'November', 'December'
];

export const PERIOD =  'Period';
export const PAYMENT = 'Payment';
export const PAID_BY = 'Paid By';
export const BALANCE = 'Balance';